import type { FilterMainComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import { FilterRange } from '@/app/common/filters/types/range/FilterRange.tsx';
import { useScaledRangeFilter } from '@/app/common/filters/types/range/useScaledRangeFilter.ts';

export const PriceRangeFilter = ({
  filter,
  columns,
  isLoading,
  handleFilterChanged,
  sectionTitle,
}: FilterMainComponentProps) => {
  const scaled = useScaledRangeFilter({ filter, handleFilterChanged });

  return (
    <FilterRange
      filter={scaled.filter}
      columns={columns}
      isLoading={isLoading}
      handleFilterChanged={scaled.handleFilterChanged}
      roundTo={scaled.roundTo}
      sectionTitle={sectionTitle}
    />
  );
};
